import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.374 7.26a3.277 3.277 0 0 0-4.635-4.634L12 3.365l.031.093c.271.78.783 1.805 1.744 2.766A7.3 7.3 0 0 0 16.635 8z",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.034 3.334-.032.032.031.093c.271.78.782 1.804 1.744 2.766A7.3 7.3 0 0 0 16.635 8l-7.134 7.134c-.48.48-.721.721-.986.928a5.5 5.5 0 0 1-1.01.624c-.303.145-.626.252-1.271.467l-3.403 1.134a.884.884 0 0 1-1.118-1.117l1.135-3.403c.215-.646.322-.968.467-1.272q.256-.538.624-1.009c.207-.265.447-.506.928-.987z"
    }, null, -1)
  ])))
}
export default { render: render }